<template>
    <div>
        <ul class="assessments-to-do">
            <li v-for="(data, assessmentTypeId) in params.value">
                <div class="enabled">
                    <b-img :src="getIcon(assessmentTypeId)" width="25"></b-img>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      icons: {
        2: require('@/assets/images/compliance-icons/fire.svg'),
        3: require('@/assets/images/compliance-icons/legion.svg'),
        4: require('@/assets/images/compliance-icons/asbes.svg'),
        5: require('@/assets/images/compliance-icons/elec.svg'),
        6: require('@/assets/images/compliance-icons/stock.svg'),
        7: require('@/assets/images/compliance-icons/gas.svg'),
      },
    };
  },
  methods: {
    getIcon(assessmentTypeId) {
      return this.icons[assessmentTypeId];
    },
  },
});
</script>

<style lang="scss">
    ul.assessments-to-do {
        padding: 0;

        li {
            margin-left: 5px;
            display: inline-block;
            font-size: 22px;

            div {
                width: 100%;
                display: inline-block;

                &.hidden {
                    display: none;
                }
            }
        }
    }
</style>
